import IMG_FEATURED_PIN from './img/img_popular_spaces.svg?url';
import IMG_NORMAL_PIN from './img/img_pinpoint_map.svg?url';
import IMG_RATING_STAR from './img/img_star.svg?url';

const NON_NUMERIC = /[^0-9-.]/g;

window.Page = window.Page || {};
let Page = window;
Page.baseUrl = hydrateJSON.baseUrl;
Page.countryCities = hydrateJSON.cities,
Page.cloudFrontUrl = hydrateJSON.cloudFrontUrl;
Page.cityId = hydrateJSON.cityId;
Page.countryId = hydrateJSON.countryId;
Page.viewMode = hydrateJSON.viewMode;
Page.networkCode = hydrateJSON.networkCode;
Page.currentPageNum = hydrateJSON.currentPageNum;
Page.pricingMax = hydrateJSON.priceMax;
Page.filters = [];
Page.filters.amenityIds = [];
Page.filters.maxMeetingRoomCapacity = 0;
Page.filters.pricingStart = null;
Page.filters.pricingEnd = null;

Page.filters.resourceTypes = 'all';
Page.filters.durationMetricTypes = 'all';

export function loadSearchResults(pageNum) {
    Page.currentPageNum = pageNum;

    let postParams = {
        "city_id": Page.cityId,
        "country_id": Page.countryId,
        "view_mode": Page.viewMode,
        "network_code": Page.networkCode,
        "page_num": Page.currentPageNum,
        "filter_amenity_ids": Page.filters.amenityIds,
        "filter_meeting_room_capacity": Page.filters.maxMeetingRoomCapacity,
        "filter_price_start": Page.filters.pricingStart,
        "filter_price_end": Page.filters.pricingEnd,
        "filter_resource_types": Page.filters.resourceTypes,
        "filter_duration_metric_types": Page.filters.durationMetricTypes,
        "page_size": Page.pageSize,
    };

    fetchSearchResults(postParams)
}

function fetchSearchResults(postParams){
    $.ajax({
        type: 'POST',
        url: Page.baseUrl + "ajax/spaces",
        data: postParams,
        success: function (data) {
            var cityLink = $(".network-search-all-spaces-link").clone();
            $("#search_results").html(data.renderedResults);
            if (cityLink.length > 0) {
                $("#search_results").append(cityLink);
            }
            if (typeof open_network_city !== 'undefined') {
                $('.search-space-main-outer').on('click', open_network_city);
            }
            if (hydrateJSON.viewMode == 'map') {
                renderMapMarkers(data.mapSpaces, data.centerCoordinatesJSON);
            }
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#search_results").offset().top - 100
            }, 0);
            $("#num_spaces").html(data.numSpaces);
            $("#desk_count").html(data.deskCount);
            $("#private_office_count").html(data.privateOfficeCount);
            $("#meeting_room_count").html(data.meetingRoomCount);
            $("#virtual_office_count").html(data.virtualOfficeCount);
        },
        error: function (result) {
            $("#search_results").html("<p>There was an issue fetching your search results</p>");
        },
        fail: (function (status) {
            $("#search_results").html("<p>There was an issue fetching your search results</p>");
        }),
        beforeSend: function (d) {
            //$('#reviews').html("<center><strong style='color:red'>Please Wait...<br><img height='25' width='120' src='<?php echo base_url();?>img/ajax-loader.gif' /></strong></center>");
        }
    });
}

function clusterMarkerCalculator(
    markers,
    numStyles
) {
    let index = 0;
    const count = markers.length;

    let dv = count;
    while (dv !== 0) {
        dv = Math.floor(dv / 10);
        index++;
    }

    index = Math.min(index, numStyles);
    return {
        text: count.toString() + ' spaces',
        index: index,
        title: "",
    };
}
function renderMapMarkers(coordinateData, centerCoordinates = []) {
    if (coordinateData.length == 0) {
        var map = new google.maps.Map(document.getElementById('map'), {
            zoom: 10,
            center: new google.maps.LatLng(centerCoordinates[0], centerCoordinates[1]),
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        return;
    }
    var markerSelected = null;
    var locations = coordinateData;
    var bounds = new google.maps.LatLngBounds();

    locations.forEach(location => {
        bounds.extend({lat: Number(location.location.lat), lng: Number(location.location.lng)});
    });

    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 10,
        center: bounds.getCenter(),
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    map.setCenter(bounds.getCenter());
    map.fitBounds(bounds, 100);

    var infowindow = new google.maps.InfoWindow();

    var marker, i;

    var markers = locations.map(function (space) {
        marker = new google.maps.Marker({
            position: new google.maps.LatLng(space.location.lat, space.location.lng),
            map: map,
            icon: (space.is_featured ? IMG_FEATURED_PIN : IMG_NORMAL_PIN)
        });
        space.marker = marker;
        var handleMarkerSelect = (function (marker, i, location) {
            return function () {
                if (markerSelected === location.id) return;

                markerSelected = location.id;
                let html = '';
                html += '<div class="map-infobox-hover-inner">';
                html += '<div class="col-xs-12 pad-none map_pic">';
                html += '<a target="_blank" href="' + encodeURI(location.profile_url_full) + '" style="text-align: center; display: block;"><img src="' + encodeURI(location.profile_image.url) + '">';
                html += '</a>';
                html += '</div>';
                if (location.list_pricing?.desk_month?.price > 0) {
                    html += '<div class="col-12 pad-none map-infobox-hover-space-name">' + location.list_pricing.desk_month.price + location.currency_code + '</div>';
                } else {
                    html += '<div class="col-12 pad-none map-infobox-hover-space-name">&nbsp;</div>';
                }
                html += '<h6>' + location.name + '</h6>';
                html += '<div class="col-12 pad-none map-infobox-hover-reviews">';
                for (i = 0; i < location.reviews_summary?.overall_rating_data.whole; i++) {
                    html += '<img src="' + IMG_RATING_STAR + '" alt="star">';
                }
                if (location.reviews_summary?.overall_rating_data.use_half_star) {
                    html += '<img src="' + IMG_RATING_STAR + '" alt="star">';
                }
                html += '</div>';
                infowindow.setContent(html);
                infowindow.open(map, marker);
                map.setCenter(marker.getPosition());
            }
        })(marker, i, space);
        google.maps.event.addListener(marker, 'click', handleMarkerSelect);
        const el = document.getElementById('search-space-' + space.id);
        if (el && !window.MarkerClusterer) {
            el.addEventListener('mouseenter', handleMarkerSelect);
        }
        return marker;
    });
    //if (window.MarkerClusterer && locations.length > 150) { // temporary places here for testing
    if (window.MarkerClusterer) {

        new MarkerClusterer(map, markers, {
            clusterClass: 'marker-cluster',
            minimumClusterSize:10,
            styles: [
                {
                    width: 100,
                    height: 50,
                },
                {
                    width: 100,
                    height: 50,
                },
                {
                    width: 100,
                    height: 50,
                },
            ],
            calculator: clusterMarkerCalculator
        });
    }
}

var priceStart = hydrateJSON.priceStart;
var priceEnd = hydrateJSON.priceEnd;
$("#d1 input").on('change', function () {
    let start = Number(this.value.replace(NON_NUMERIC, ''));
    start = Math.max(Math.min(start, Page.filters.pricingEnd), 0);
    Page.filters.pricingStart = start;
    this.value = start;
    $("#monthly-price-slider").slider('values', [start, Page.filters.pricingEnd]);
});
$("#d2 input").on('change', function () {
    let end = Number(this.value.replace(NON_NUMERIC, ''));
    end = Math.max(Math.min(end, priceEnd), 0, Page.filters.pricingStart);
    Page.filters.pricingEnd = end;
    this.value = end;
    $("#monthly-price-slider").slider('values', [Page.filters.pricingStart, end]);
});
async function setupPriceSlider() {
    Page.filters.pricingStart = priceStart;
    Page.filters.pricingEnd = priceEnd;
    await import('../../_shared/vendor/jquery-ui-slider');

    $("#monthly-price-slider").slider({
        min: priceStart,
        max: priceEnd,
        range: true,
        values: [priceStart, priceEnd],
        slide: function (event, ui) {
            const start = ui.values[0];
            const end = ui.values[1];
            $("#d1 input").val(start);
            $("#d2 input").val(end);
            Page.filters.pricingStart = start;
            Page.filters.pricingEnd = end;
        }
    });

    $("#d1 input").val(0);
    $("#d2 input").val(Page.pricingMax);
}


window.addEventListener('scroll', () => {
    requestAnimationFrame(() => {
        const mapsScript = document.createElement('script');
        mapsScript.async = true;
        mapsScript.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCrDWVmZFIo_jp5aJUvJYDU_wMXK7PMA6Q&callback=initMap&libraries=&v=weekly';
        document.head.appendChild(mapsScript);
    });
}, {passive: true, once: true});

window.initMap = () => {
    if (hydrateJSON.viewMode === 'map' || hydrateJSON.viewMode === 'city') {
        renderMapMarkers(hydrateJSON.mapSpaces, hydrateJSON.centerCoordinates);
    }
}

$(function () {

    $('.home-input-radio.durations').on('click', function (e) {

        Page.filters.durationMetricTypes = [];
        $.each($('input[name="durations"]:checked'), function () {
            Page.filters.durationMetricTypes.push($(this).val());
        });

        if (Page.filters.durationMetricTypes == false) {
            Page.filters.durationMetricTypes = null;
        }

        loadSearchResults(Page.currentPageNum);

    });

    // FILTER SAVE BUTTONS
    $('.home-input-radio.resource-types').on('click', function (e) {
        Page.filters.resourceTypes = [];
        $.each($('input[name="resource_types"]:checked'), function () {
            Page.filters.resourceTypes.push($(this).val());
        });

        loadSearchResults(Page.currentPageNum);
    });


    $('#save_price_range_button').on('click', function (e) {
        e.preventDefault();
        loadSearchResults(Page.currentPageNum);
    });

    $('#save_meeting_capacity_button').on('click', function (e) {
        e.preventDefault();
        loadSearchResults(Page.currentPageNum);
    });

    $('body').on('click', 'a.search-page-link', function (e) {
        e.preventDefault();
        let PageNum = $(this).data("search-page-num");
        loadSearchResults(PageNum);

    });

    //SEARCH PAGE TOGGLES
    $(".map-view-dropdown").on('click', function () {
        $(".map-dropdown-toggle").toggle();
    });
})


var init_div = false;
var init_div2 = false;
$(".view-filters").on('click', function (e) {

    if (init_div == false) {
        $(".space-mapview-filter-outer").show();
        init_div = true;
    } else {
        $(".space-mapview-filter-outer").hide();
        init_div = false;
    }
    init_div2 = false;
    e.stopPropagation();
    e.preventDefault();
});

$('.price-range-save-button').on('click', function () {
    $(".space-mapview-filter-outer").hide();
    init_div = false;
});

$('.price-range-save-button').on('click', function () {
    $(".coworker-price-range-dropdown02").hide();
    init_div2 = false;
});

$(".price-range").on('click', function (e) {

    //coworker-price-range-dropdown02
    if (init_div2 == false) {
        $(".coworker-price-range-dropdown02").show();
        init_div2 = true;
    } else {
        $(".coworker-price-range-dropdown02").hide();
        init_div2 = false;
    }
    //price-range-save-button

    init_div = false;
    e.stopPropagation();
    e.preventDefault();
});

$(".view-filters-lists-outer li a").on('click', function () {
    $(this).toggleClass("filter-selected");
});



$('#clear_price_range_button').on('click', function (e) {
    e.preventDefault();
    setupPriceSlider();
});

$(document).on('mouseup', function (e) {
    var container = $(".space-mapview-filter-outer");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.hide();
    }
    var container2 = $(".map-dropdown-toggle");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container2.is(e.target) && container2.has(e.target).length === 0) {
        container2.hide();
    }

    var container3 = $(".coworker-price-range-dropdown02");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container3.is(e.target) && container3.has(e.target).length === 0) {
        container3.hide();
    }
});


requestAnimationFrame(async () => {
    // Only load if the page gets interaction
    await new Promise((resolve) => {
        window.addEventListener('scroll', resolve, { once: true, passive: true });
        document.addEventListener('click', resolve, { once: true, passive: true });
        document.addEventListener('keydown', resolve, { once: true, passive: true });
    });
    setupPriceSlider();
})